import { ReactNode } from "react";
import { DndProvider } from "react-dnd";
import { MultiBackend, getBackendOptions } from "@minoru/react-dnd-treeview";

/** Multi-backend DnD for map widget editor (HTML5 + touch; Safari popover sort). */
export function MapWidgetDndProvider({ children }: { children: ReactNode }) {
  return (
    <DndProvider backend={MultiBackend} options={getBackendOptions()}>
      {children}
    </DndProvider>
  );
}
